// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"LostPage404_text-gradient__3I9gt","top":"LostPage404_top__3OvHe","body":"LostPage404_body__1NKi3","title":"LostPage404_title__3lVHA"};